/**
 * Initializes GLightbox for photo gallery sections
 * Each .photo-gallery-bar-section container has its own scoped lightbox gallery
 */
function initializePhotoGalleries(): void {
  // Find all photo gallery bar section containers on the page
  const galleryContainers = document.querySelectorAll('.photo-gallery-bar-section');

  // Initialize a separate lightbox gallery for each container
  galleryContainers.forEach((container, index) => {
    // Select all anchor tags within the current container - each anchor wraps a thumbnail
    // and its href points to the full-size image to be displayed in the lightbox
    const anchors = container.querySelectorAll<HTMLAnchorElement>('a[href]');

    // Only initialize lightbox if the container has gallery links
    if (anchors.length > 0) {
      // Create a group identifier for this gallery to scope lightbox to this container
      const galleryGroup = `photo-gallery-${index}`;

      anchors.forEach((anchor) => {
        // Tag each anchor with the gallery group so GLightbox can group them together
        anchor.setAttribute('data-gallery', galleryGroup);

        // Prevent the browser from navigating to the full-size image URL on click;
        // GLightbox will intercept the click and open the lightbox instead
        anchor.addEventListener('click', (e) => e.preventDefault());
      });

      // Initialize GLightbox for this specific gallery group
      // GLightbox uses the anchor's href as the full-size image source displayed in the lightbox
      GLightbox({
        selector: `[data-gallery="${galleryGroup}"]`,
      });
    }
  });
}

// Initialize photo galleries when the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePhotoGalleries);
} else {
  // DOM is already loaded
  initializePhotoGalleries();
}
